import { useEffect } from "react";

const B = {
  blue:"#1b57ce", blueD:"#1245a8", blueL:"#e8f0fd",
  orange:"#ea592d", white:"#ffffff", gray:"#f4f5f7",
  grayB:"#e8eaed", muted:"#6b7280", text:"#111827",
};

const EMPRESA  = "Carga Express, Sociedad Anónima de Capital Variable";
const NIT      = "0614-051222-106-6";
const NRC      = "326398-5";
const DIRECCION= "C. Urb. Santa Tecla, Calle 4ta Oriente, Oficina 1-6, Santa Tecla, La Libertad, El Salvador";
const CORREO   = "flashboxsv@gmail.com";
const WA       = "https://wa.me/50378427302";
const FECHA    = "1 de julio de 2025";

const secciones = [
  {
    titulo: "1. Identificación de la Empresa",
    contenido: `El presente sitio web y la plataforma de servicios courier son operados por ${EMPRESA}, con NIT ${NIT} y NRC ${NRC}, con domicilio en ${DIRECCION}, en adelante denominada "Flashbox".`,
  },
  {
    titulo: "2. Objeto del Servicio",
    contenido: `Flashbox presta servicios de gestión de importaciones y entrega de paquetes desde los Estados Unidos de América (Miami, Florida) hacia El Salvador. El servicio incluye: (a) provisión de una dirección de recepción en Miami; (b) recepción, consolidación y gestión aduanal de los paquetes; (c) transporte y entrega en El Salvador conforme a las condiciones pactadas.`,
  },
  {
    titulo: "3. Aceptación de los Términos",
    contenido: `El uso del portal web, la creación de una cuenta o la utilización de cualquier servicio de Flashbox implica la aceptación plena y sin reservas de los presentes Términos y Condiciones. Si no está de acuerdo con alguna de las condiciones aquí establecidas, deberá abstenerse de utilizar los servicios.`,
  },
  {
    titulo: "4. Registro y Cuenta de Usuario",
    contenido: `Para utilizar el servicio es necesario crear una cuenta personal. El usuario se compromete a proporcionar información verídica, completa y actualizada, incluyendo número de Documento Único de Identidad (DUI) y datos de contacto. Flashbox se reserva el derecho de suspender o cancelar cuentas que presenten información falsa o incompleta. El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso.`,
  },
  {
    titulo: "5. Tarifas y Precios",
    contenido: `El costo del servicio de flete se calcula por libra o fracción, conforme a la tabla de precios por volumen vigente publicada en el sitio web:\n\n• 1–10 lbs: $5.00/lb\n• 11–25 lbs: $4.50/lb\n• 26–50 lbs: $4.00/lb\n• 51–80 lbs: $3.75/lb\n• 81–100 lbs: $3.50/lb\n• 100+ lbs: $3.25/lb\n\nEl peso final se determina al recibir el paquete en bodega de Miami. Los valores mostrados en el cotizador son estimaciones. Flashbox se reserva el derecho de modificar las tarifas con previo aviso publicado en el sitio web.`,
  },
  {
    titulo: "6. Impuestos y Derechos Aduanales",
    contenido: `El usuario es responsable del pago de los impuestos y derechos aduanales correspondientes conforme a la legislación salvadoreña vigente. Para compras inferiores a $300.00 USD se aplica únicamente el IVA del 13% sobre el valor aduanal. Para compras iguales o superiores a $300.00 USD se aplica adicionalmente el Derecho Arancelario a la Importación (DAI) según la categoría del producto. El valor aduanal se calcula sobre el precio del producto más el 10% de flete estimado y el 1.5% de seguro, conforme a la Ley de Facilitación de Importaciones de Compras en Línea de El Salvador.`,
  },
  {
    titulo: "7. Prohibiciones y Mercancía Restringida",
    contenido: `Queda estrictamente prohibido importar mediante Flashbox: artículos ilegales conforme a la legislación salvadoreña, armas de fuego y municiones, sustancias controladas o narcóticos, explosivos, materiales inflamables o peligrosos, animales vivos, productos perecederos que requieran cadena de frío, y cualquier mercancía cuya importación esté expresamente prohibida por la legislación de El Salvador o de los Estados Unidos. Flashbox no se hace responsable por las consecuencias legales derivadas del incumplimiento de esta cláusula.`,
  },
  {
    titulo: "8. Responsabilidad y Seguros",
    contenido: `Flashbox no asume responsabilidad por daños, pérdidas o retrasos causados por: fuerza mayor, caso fortuito, actos de autoridades aduanales o gubernamentales, embalaje inadecuado por parte del remitente, o información incorrecta proporcionada por el usuario. Se recomienda al usuario contratar un seguro de envío para artículos de alto valor. Flashbox gestionará de buena fe cualquier reclamación presentada, pero su responsabilidad máxima se limita al valor del flete pagado por el paquete afectado.`,
  },
  {
    titulo: "9. Tiempos de Entrega",
    contenido: `El tiempo estimado de entrega es de 5 a 10 días hábiles contados a partir de la recepción del paquete en la bodega de Miami. Este plazo es estimativo y puede verse afectado por trámites aduanales, volumen de operaciones, festivos o situaciones de fuerza mayor. Flashbox no garantiza fechas exactas de entrega.`,
  },
  {
    titulo: "10. Entregas a Domicilio",
    contenido: `Flashbox realiza entregas a domicilio en el Gran San Salvador (San Salvador, Santa Tecla y Antiguo Cuscatlán) sin costo adicional. Para entregas en el interior del país se aplicará un cargo adicional aproximado de $5.00 USD, sujeto a confirmación según la ubicación exacta.`,
  },
  {
    titulo: "11. Modificaciones a los Términos",
    contenido: `Flashbox se reserva el derecho de modificar los presentes Términos y Condiciones en cualquier momento. Los cambios serán publicados en el sitio web y entrarán en vigencia a partir de su publicación. El uso continuado del servicio tras la publicación de los cambios implica la aceptación de los nuevos términos.`,
  },
  {
    titulo: "12. Legislación Aplicable y Jurisdicción",
    contenido: `Los presentes Términos y Condiciones se rigen por las leyes de la República de El Salvador. Cualquier controversia que surja en relación con los mismos será sometida a los tribunales competentes de la República de El Salvador, con renuncia expresa a cualquier otro fuero que pudiera corresponder.`,
  },
  {
    titulo: "13. Contacto",
    contenido: `Para consultas, reclamos o cualquier comunicación relacionada con el servicio:\n\nCorreo electrónico: ${CORREO}\nWhatsApp: +503 7842-7302\nDirección: ${DIRECCION}`,
  },
];

export default function Terminos() {
  useEffect(() => {
    document.title = "Términos y Condiciones — Flashbox";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: B.white, minHeight: "100vh", color: B.text }}>

      {/* Header */}
      <div style={{ background: B.blue, padding: "28px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <a href="/" style={{ textDecoration: "none" }}>
            <span style={{ fontSize: 22, fontWeight: 900, color: B.white, letterSpacing: "-0.5px" }}>
              Flash<span style={{ color: "#f6e24d" }}>box</span>
            </span>
          </a>
          <a href="/" style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", textDecoration: "none", fontWeight: 600 }}>
            ← Volver al inicio
          </a>
        </div>
      </div>

      {/* Contenido */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px 80px" }}>

        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontSize: 32, fontWeight: 900, color: B.text, marginBottom: 8, letterSpacing: "-0.5px" }}>
            Términos y Condiciones
          </h1>
          <p style={{ fontSize: 14, color: B.muted }}>
            Última actualización: {FECHA} · {EMPRESA}
          </p>
        </div>

        {/* Intro */}
        <div style={{ background: B.blueL, borderRadius: 12, padding: "20px 24px", marginBottom: 40, borderLeft: `4px solid ${B.blue}` }}>
          <p style={{ fontSize: 15, color: B.text, lineHeight: 1.7, margin: 0 }}>
            Estos Términos y Condiciones regulan el uso de los servicios ofrecidos por <strong>{EMPRESA}</strong> a través de la plataforma Flashbox. Lea detenidamente este documento antes de utilizar nuestros servicios.
          </p>
        </div>

        {/* Secciones */}
        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          {secciones.map((s) => (
            <div key={s.titulo}>
              <h2 style={{ fontSize: 17, fontWeight: 800, color: B.text, marginBottom: 10 }}>{s.titulo}</h2>
              <p style={{ fontSize: 15, color: "#374151", lineHeight: 1.8, margin: 0, whiteSpace: "pre-line" }}>
                {s.contenido}
              </p>
            </div>
          ))}
        </div>

        {/* Footer legal */}
        <div style={{ marginTop: 56, paddingTop: 32, borderTop: `1px solid ${B.grayB}`, display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ fontSize: 13, color: B.muted, margin: 0 }}>
            © 2025 {EMPRESA} · NIT {NIT}
          </p>
          <div style={{ display: "flex", gap: 20 }}>
            <a href="/privacidad" style={{ fontSize: 13, color: B.blue, textDecoration: "none", fontWeight: 600 }}>Privacidad</a>
            <a href="/" style={{ fontSize: 13, color: B.blue, textDecoration: "none", fontWeight: 600 }}>Inicio</a>
          </div>
        </div>
      </div>
    </div>
  );
}
